import styled from 'styled-components'
import { theme, Box, Content } from '@/client/components'
const { breakpoint, color, space } = theme

export const Cards = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: ${space.xl};
  margin-bottom: ${space.xl3};

  @media (min-width: ${breakpoint.lg}) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const Card = styled(Box)<{ bgColor: string }>`
  padding: ${space.xl3} ${space.xl2};
  background-color: ${({ bgColor }) => (bgColor === 'dark' ? color.primary.darker : color.primary.pure)};
`

export const CardContent = styled(Content)`
  margin: 0;

  p {
    margin-bottom: ${space.xs2};
  }
`
